import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
import { beforeItems, afterItems } from '../data/framework';
export function BeforeAfter() {
  return <section className="w-full bg-cream px-4 py-16 sm:py-24" data-id="element-23" data-mp="3ofhxvfzy3nzu">
      <div className="mx-auto max-w-6xl" data-id="element-24" data-mp="3sgbjg2px0qpk">
        <SectionHeading title="The Difference a Clear Structure Makes" data-id="element-25" data-mp="3sjftvhtz4ioo" />

        <div className="mt-12 grid gap-6 lg:grid-cols-2" data-id="element-26" data-mp="3eodhcbumfv2w">
          <div className="overflow-hidden rounded-3xl bg-white ring-1 ring-gum/20" data-id="element-27" data-mp="3jh6m2zq3b3ez">
            <div className="bg-gum px-6 py-4 text-center" data-id="element-28" data-mp="34rsdvuy92s16">
              <h3 className="text-lg font-black uppercase tracking-wider text-white" data-id="element-29" data-mp="34td7nicqq6xz">Before Perio Blueprint™</h3>
            </div>
            <ul className="space-y-4 p-6" data-id="element-30" data-mp="39oitkh657lm2">
              {beforeItems.map(item => <li key={item} className="flex gap-3 text-[16px] leading-relaxed text-ink/85" data-id="element-31" data-mp="2vt6trvd4r4ya">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-gum-light" data-id="element-32" data-mp="30s9p2o3b5wt2">
                    <XIcon className="h-4 w-4 text-gum" strokeWidth={3} aria-hidden="true" data-id="element-33" data-mp="t2yudoynu21d" />
                  </span>
                  <span data-id="element-34" data-mp="1739kuqw25em0">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="overflow-hidden rounded-3xl bg-white ring-2 ring-cta" data-id="element-35" data-mp="123dhmtv6pr7i">
            <div className="bg-cta px-6 py-4 text-center" data-id="element-36" data-mp="edswc4bk6hv2">
              <h3 className="text-lg font-black uppercase tracking-wider text-white" data-id="element-37" data-mp="eec3cpzo7lub">With Perio Blueprint™</h3>
            </div>
            <ul className="space-y-4 p-6" data-id="element-38" data-mp="o3vpq5mldxtx">
              {afterItems.map(item => <li key={item} className="flex gap-3 text-[16px] font-medium leading-relaxed text-ink" data-id="element-39" data-mp="o5oxxpcusq41">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-cta" data-id="element-40" data-mp="jbcdpd3jzar8">
                    <CheckIcon className="h-4 w-4 text-white" strokeWidth={3} aria-hidden="true" data-id="element-41" data-mp="3mu5jh3q3avau" />
                  </span>
                  <span data-id="element-42" data-mp="1qriwv93pk1kc">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-10 max-w-2xl space-y-3 text-center text-[17px] leading-relaxed text-ink/85 sm:text-lg" data-id="element-43" data-mp="1voj3pm8dt8ci">
          <p data-id="element-44" data-mp="20inekgkrq0iv">The goal isn’t to make complex periodontal cases artificially simple.</p>
          <p className="font-serif text-2xl font-bold text-brand-dark" data-id="element-45" data-mp="24hcou0aif1ya">
            It’s to help you approach the information in a more organized and systematic way.
          </p>
        </div>

        <div className="mt-10" data-id="element-46" data-mp="1crhxxz70747i">
          <CTAButton label="Yes, I Want the Perio Blueprint™" data-id="element-47" data-mp="1cst0jvopq5x1" />
        </div>
      </div>
    </section>;
}